<script setup lang="ts">
import { Library, Tags } from '@lucide/vue'
import { Button } from 'catalyst-vue'
import { useRoute, useRouter } from 'vue-router'
import { useControlSize } from '../../lib/library-layout'

/** compact 版面的底部導覽：兩個目的地固定，頁面自己的主要動作由 actions slot 提供。 */
const route = useRoute()
const router = useRouter()
const controlSize = useControlSize()
</script>

<template>
  <nav class="library-bottom-nav" aria-label="書庫導覽">
    <div class="bottom-nav-inner">
      <Button plain :size="controlSize" class="bottom-nav-destination" :aria-current="route.path === '/library' ? 'page' : undefined" @click="router.push('/library')">
        <Library :size="21" :stroke-width="1.6" aria-hidden="true" /><span>書庫</span>
      </Button>
      <Button plain :size="controlSize" class="bottom-nav-destination" :aria-current="route.path === '/categories' ? 'page' : undefined" @click="router.push('/categories')">
        <Tags :size="21" :stroke-width="1.6" aria-hidden="true" /><span>分類管理</span>
      </Button>
      <div class="bottom-nav-primary"><slot name="actions" /></div>
    </div>
  </nav>
</template>
